<template>
  <v-layout row wrap>
    <TemplateItemDialog :dialogAuditItem.sync="dialogAuditItem" v-if="dialogAuditItem" />
    <SelectTemplateItemsDialog
      :templatedialog.sync="templatedialog"
      currentStore="templates"
      :currentAudit="currentTemplate"
      v-if="templatedialog"
    />
    <AuditProcessContainer>
      <GroupableItemList
        slot="container_content"
        :list-items="templateItems"
        :manipulators="templateItemManipulators"
        list-config-key="templatePreperation"
        :actions="listActions"
        @use-template="templatedialog = true"
      >
        <template v-slot:default="{ item }">
          <AuditItemRow :key="item.id">
            <AuditQuestion
              slot-scope="{ hover }"
              :hover="hover"
              slot="question"
              :severity="item.question.importance"
            >
              <AuditQuestionRowComponent
                slot="content"
                :question="item.question"
                :standard="currentTemplate.standard"
              />

              <AuditProcessMenu
                v-if="hover"
                slot="actions"
                slot-scope="{ hover }"
                :actions="getTemplateItemActions"
                :context="item.id"
                @itemdelete="deleteCurrentAuditItem(templateId, item.id)"
                @itemupdate="updateAuditItem(templateId, item.id, item)"
              />
            </AuditQuestion>
          </AuditItemRow>
        </template>
      </GroupableItemList>
    </AuditProcessContainer>

    <v-btn
      fab
      :style="fabStyle"
      bottom
      right
      color="pink"
      dark
      fixed
      @click="createAuditItem(templateId)"
    >
      <v-icon>add</v-icon>
    </v-btn>
  </v-layout>
</template>

<i18n>
{
  "de": {
    "importance": "Bedeutung",
    "audititem": "Auditfrage",
    "category": "Kategorie",
    "chapter" : "Kapitel",
    "create_item": "Frage erstellen",
    "use_template": "Vorlage nutzen"
  },
  "en": {
    "importance": "Importance",
    "audititem": "Auditquestion",
    "category": "Category",
    "chapter" : "Chapter",
    "create_item": "Create Question",
    "use_template": "Use Template"
  }
}
</i18n>

<script>
// Dialogs
import TemplateItemDialog from "@/components/dialogs/TemplateItemDialog.vue";
import SelectTemplateItemsDialog from "@/components/dialogs/SelectTemplateItemsDialog.vue";

// Layouts
import AuditProcessContainer from "@/components/layouts/BaseLayouts/AuditProcessContainer.vue";
import AuditItemRow from "@/components/layouts/AuditPreparation/AuditItemRow.vue";
import AuditQuestion from "@/components/layouts/BaseLayouts/AuditQuestion.vue";
import GroupableItemList from "@/components/layouts/BaseLayouts/GroupableItemList";

// Controls/Snippets
import AuditProcessMenu from "@/components/controls/AuditProcessMenu.vue";

// Components
import AuditQuestionRowComponent from "@/components/widgets/AuditQuestionRowComponent.vue";

// Mixins
import FabMixin from "@/components/mixins/FabMixin.vue";
import TemplateItemListMixin from "@/components/mixins/TemplateItemListMixin";

import { mapActions, mapGetters } from "vuex";
import { api } from "@/store/modules/templates";
import { api as confApi } from "@/store/modules/configuration";

export default {
  components: {
    TemplateItemDialog,
    SelectTemplateItemsDialog,
    AuditProcessContainer,
    AuditItemRow,
    AuditQuestionRowComponent,
    AuditQuestion,
    AuditProcessMenu,
    GroupableItemList
  },
  mixins: [TemplateItemListMixin, FabMixin],
  data() {
    return {
      dialogAuditItem: false,
      templatedialog: false,
      listActions: [
        {
          title: this.$i18n.t("use_template"),
          event: "use-template"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(confApi.namespace, [confApi.getters.getTemplateItemActions])
  },
  methods: {
    ...mapActions(api.namespace, [
      api.actions.importActionSet,
      api.actions.setAuditId,
      api.actions.setAuditItemId,
      api.actions.setDialogItem,
      api.actions.setDialogAction,
      api.actions.deleteAuditItem
    ]),
    createAuditItem(audit_id) {
      this.setDialogItem({ question: { chapters: [] } });
      this.setDialogAction("create");
      this.setAuditId(audit_id);

      this.dialogAuditItem = true;
    },
    updateAuditItem(audit_id, audititem_id, audititem) {
      this.setAuditId(audit_id);
      this.setAuditItemId(audititem_id);
      this.setDialogItem({ ...audititem });
      this.setDialogAction("update");

      this.dialogAuditItem = true;
    },
    deleteCurrentAuditItem(audit_id, audititem_id) {
      //this.setAuditId(audit_id);
      //this.setAuditItemId(audititem_id);
      //this.setDeviationId(deviation_id);

      const payload = { audit_id: audit_id, audititem_id: audititem_id };

      confirm("Are you sure you want to delete this audit item?") &&
        this.deleteAuditItem(payload);
    }
  }
};
</script>
